import DictionaryGridTileContainer from 'components/DictionaryGridTile/DictionaryGridTileContainer'
import DictionaryGridTilePresentation from 'components/DictionaryGridTile/DictionaryGridTilePresentation'
import DictionaryGridTilePresentationKids from 'components/DictionaryGridTile/DictionaryGridTilePresentationKids'

export default {
  Container: DictionaryGridTileContainer,
  Presentation: DictionaryGridTilePresentation,
  PresentationKids: DictionaryGridTilePresentationKids,
}
